import React, { useState, useRef, ChangeEvent, DragEvent } from "react";
import clsx from "clsx";
import { FileUploadSVGIcon } from "components/SVGIcons";
import styles from "./style.module.scss";

interface FileUploaderProps {
  isCarrierSubscribed: boolean;
  onFileSelect: (file: File) => void;
}

export default function FileUploader({ isCarrierSubscribed, onFileSelect }: FileUploaderProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      onFileSelect(e.target.files[0]);
      resetFileInput();
    }
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDragOver = (e: DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e: DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onFileSelect(e.dataTransfer.files[0]);
      try {
        resetFileInput();
        e.dataTransfer.clearData();
      } catch (error) {
        // console.warn("Resetting the file input failed:", error);
      }
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <label
      className={clsx(
        styles.uploader,
        isCarrierSubscribed ? "flex-col gap-6 p-3 mt-5 border-dashed !border-2" : "",
        isDragging && styles.dragging
      )}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}>
      <FileUploadSVGIcon className="size-8 desktop:size-16" />
      <span className={isCarrierSubscribed ? "text-subtitle" : ""}>
        {isCarrierSubscribed
          ? isDragging
            ? "Drop files here"
            : "Choose files to upload or drag and drop them here"
          : "Choose Files to upload"}
      </span>
      <input type="file" ref={fileInputRef} onChange={handleFileChange} hidden />
    </label>
  );
}
